import React from 'react';
import './ShoppingCart.css';

const CartItem = ({ item, onRemove }) => {
  
  return (
    <div className="cart-item">
      {/* Asumo que 'item.images' es un array de URLs */}
      <img src={item.images?.[0] || 'https://via.placeholder.com/150'} alt={item.name} className="cart-item-image" />
      <div className="cart-item-details">
        <h4>{item.name}</h4>
        {/* Asumo que 'item.user' es un objeto con 'name' */}
        <p>Vendido por: {item.user?.name || 'Vendedor Desconocido'}</p>
        <p>Cantidad: {item.quantity}</p>
        <button 
          className="cart-item-remove"
          onClick={onRemove}
        >
          Eliminar del carrito
        </button>
      </div>
      <span className="cart-item-price">${(item.price * item.quantity).toLocaleString('es-AR')}</span>
    </div>
  );
};

export default CartItem;